export interface UserTicketSaleInformationWithTotalInterface {
  total?: number;
  totalCheckedIn?: number;
}
